import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_Person_Interface, Person_Interface } from 'src/app/Interface/Person_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PersonService } from 'src/app/Service/Person/Person.service';
import { ProvinceService } from 'src/app/Service/Province/Province.service';
import { SematService } from 'src/app/Service/Semat/Semat.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-PersonEdit',
  templateUrl: './PersonEdit.component.html',
  styleUrls: ['./PersonEdit.component.scss']
})
export class PersonEditComponent implements OnInit {

  Token: String = ""
  Edit_Record_Persone: Person_Interface = Empty_Person_Interface()
  BaseUrl = environment.BaseUrl
  EditRecord: number = 0

  constructor(
    private Person_Service: PersonService,
    private Nav_Service: NavService,
    private province_Service: ProvinceService,
    private Alertify_Service: AlertifyService,
    private Semat_Service: SematService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    this.EditNewPerson = new FormGroup({

      id: new FormControl(),
      fname: new FormControl(null, Validators.required),
      lname: new FormControl(null, Validators.required),
      sex: new FormControl("0"),
      vaziat_startDate: new FormControl(),
      vaziat_endDate: new FormControl(),
      tedadFarzandan: new FormControl(),
      shomareh_bimeh: new FormControl(),
      ProvinceId: new FormControl("0"),
      mahal_tavalod: new FormControl("0"),
      codeMeli: new FormControl(null),
      name_Hamsar: new FormControl(),
      name_Pedar: new FormControl(),
      shoghleh_Pedar: new FormControl(),
      codeMeli_Hamsar: new FormControl(null),
      shomareh_Shenasnameh: new FormControl(),
      shomareh_Shenasnameh_Seri: new FormControl(),
      shomareh_hamrah_Hamsar: new FormControl('', Validators.pattern('^[0-9]{10}$')),
      shomareh_Hamreh: new FormControl('', Validators.pattern('^[0-9]{10}$')),
      email: new FormControl('', Validators.email),
      tahsilat_Hamsar: new FormControl("0"),
      vaziat_Nazam_Vazifeh: new FormControl("0"),
      vaziat_Nazam_Vazifeh_Dsc: new FormControl(),
      vaziat_Tahol: new FormControl("0"),
      tarikh_Tavalod_Hamsar: new FormControl(),
      tarikh_Tavalod: new FormControl(),
      maskan: new FormControl("0"),
      address_Manzel: new FormControl(),
      tel: new FormControl(),
      codeposti: new FormControl(),
      shoghleh_Hamsar: new FormControl(),
      codemeli_Image1: new FormControl(),
      codemeli_Image2: new FormControl(),
      shenasNameh_Image1: new FormControl(),
      shenasNameh_Image2: new FormControl(),
      shenasNameh_Image3: new FormControl(),
      kartPayan_Khadamt_Image: new FormControl(),
      form_soe_Pishineh_Image: new FormControl(),
      ax_Personeli_Image: new FormControl(),
      ax_Personeli_Image2: new FormControl(),
      tarikh_Eshtekhdam: new FormControl(),
      almat_Ekhtesari: new FormControl(null, Validators.required),
      field_activity_id: new FormControl("0"),
      semat_id: new FormControl("0"),
      sabegh: new FormControl("0"),
    })

    this.Nav_Service.CheckValidPage(this.Token, 39).subscribe(
      data => {
        this.Read_Service_Province("")
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  ReadData_Initial_Status: boolean = false
  ReadData_Initial() {
    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))
    this.Person_Service.GetSingle(this.Token, this.EditRecord).subscribe(
      data => {
        this.Edit_Record_Persone = data['model']


        for (let itemDetail of this.Edit_Record_Persone.shomareh_hamrah_Hamsar.split(',')) {
          if (itemDetail != "-1") {
            this.Person_shomareh_hamrah_Hamsar_Array.push({
              id: 0,
              title: itemDetail,
              code: '',
              dsc: '',
              del: false,
              DeletingProccess: false
            })
          }

        }

        for (let itemDetail of this.Edit_Record_Persone.shomareh_Hamreh.split(',')) {
          if (itemDetail != "-1") {
            this.Person_shomareh_Hamreh_Array.push({
              id: 0,
              title: itemDetail,
              code: '',
              dsc: '',
              del: false,
              DeletingProccess: false
            })
          }

        }

        for (let itemDetail of this.Edit_Record_Persone.email.split(',')) {
          if (itemDetail != "-1") {
            this.Person_email_Array.push({
              id: 0,
              title: itemDetail,
              code: '',
              dsc: '',
              del: false,
              DeletingProccess: false
            })
          }

        }

        for (let itemDetail of this.Edit_Record_Persone.address_Manzel.split(',')) {
          if (itemDetail != "-1") {
            this.Person_address_Manzel_Array.push({
              id: 0,
              title: itemDetail,
              code: '',
              dsc: '',
              del: false,
              DeletingProccess: false
            })
          }

        }

        for (let itemDetail of this.Edit_Record_Persone.tel.split(',')) {
          if (itemDetail != "-1") {
            this.Person_tel_Array.push({
              id: 0,
              title: itemDetail,
              code: '',
              dsc: '',
              del: false,
              DeletingProccess: false
            })
          }

        }

        for (let itemDetail of this.Edit_Record_Persone.codeposti.split(',')) {
          if (itemDetail != "-1") {
            this.Person_codeposti_Array.push({
              id: 0,
              title: itemDetail,
              code: '',
              dsc: '',
              del: false,
              DeletingProccess: false
            })
          }

        }




        this.get_Form_fname().setValue(this.Edit_Record_Persone.fname)
        this.get_Form_lname().setValue(this.Edit_Record_Persone.lname)
        this.get_Form_shomareh_bimeh().setValue(this.Edit_Record_Persone.shomareh_bimeh)
        //this.get_Form_mahal_tavalod().setValue(this.Edit_Record_Persone.mahal_tavalod)
        this.get_Form_codeMeli().setValue(this.Edit_Record_Persone.codeMeli)
        this.get_Form_name_Hamsar().setValue(this.Edit_Record_Persone.name_Hamsar)
        this.get_Form_name_Pedar().setValue(this.Edit_Record_Persone.name_Pedar)
        this.get_Form_shoghleh_Pedar().setValue(this.Edit_Record_Persone.shoghleh_Pedar)
        this.get_Form_codeMeli_Hamsar().setValue(this.Edit_Record_Persone.codeMeli_Hamsar)
        this.get_Form_shomareh_Shenasnameh().setValue(this.Edit_Record_Persone.shomareh_Shenasnameh)
        this.get_Form_tahsilat_Hamsar().setValue(this.Edit_Record_Persone.tahsilat_Hamsar)
        this.get_Form_vaziat_Nazam_Vazifeh().setValue(this.Edit_Record_Persone.vaziat_Nazam_Vazifeh)
        this.get_Form_vaziat_Nazam_Vazifeh_Dsc().setValue(this.Edit_Record_Persone.vaziat_Nazam_Vazifeh_Dsc)
        this.get_Form_vaziat_Tahol().setValue(this.Edit_Record_Persone.vaziat_Tahol)
        this.get_Form_tarikh_Tavalod_Hamsar().setValue(this.Edit_Record_Persone.tarikh_Tavalod_Hamsar)
        this.get_Form_tarikh_Tavalod().setValue(this.Edit_Record_Persone.tarikh_Tavalod)
        this.get_Form_maskan().setValue(this.Edit_Record_Persone.maskan)
        //this.get_Form_address_Manzel().setValue(this.Edit_Record_Persone.address_Manzel)
        this.get_Form_tarikh_Eshtekhdam().setValue(this.Edit_Record_Persone.tarikh_Eshtekhdam)
        this.get_Form_almat_Ekhtesari().setValue(this.Edit_Record_Persone.almat_Ekhtesari)
        this.get_Form_field_activity_id().setValue(this.Edit_Record_Persone.field_activity_id)
        this.get_Form_semat_id().setValue(this.Edit_Record_Persone.semat_id)
        this.get_Form_shomareh_Shenasnameh_Seri().setValue(this.Edit_Record_Persone.shomareh_Shenasnameh_Seri)
        this.get_Form_shoghleh_Hamsar().setValue(this.Edit_Record_Persone.shoghleh_Hamsar)

        this.get_Form_vaziat_startDate().setValue(this.Edit_Record_Persone.vaziat_startDate)
        this.get_Form_vaziat_endDate().setValue(this.Edit_Record_Persone.vaziat_endDate)
        this.get_Form_tedadFarzandan().setValue(this.Edit_Record_Persone.tedadFarzandan)
        this.get_Form_sabegh().setValue(this.Edit_Record_Persone.sabegh)

        if (this.Edit_Record_Persone.sex == true)
          this.get_Form_Sex().setValue("1")
        else
          this.get_Form_Sex().setValue("2")

        this.get_Form_ProvinceId().setValue(data['code_Province'])


        this.Read_Service_Province(data['code_Province'])


      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  //#region  Form Add

  EditNewPerson: FormGroup;

  get_Form_id() {
    return this.EditNewPerson.get('id') as FormControl;
  }

  get_Form_fname() {
    return this.EditNewPerson.get('fname') as FormControl;
  }

  get_Form_lname() {
    return this.EditNewPerson.get('lname') as FormControl;
  }

  get_Form_sabegh() {
    return this.EditNewPerson.get('sabegh') as FormControl;
  }

  get_Form_Sex() {
    return this.EditNewPerson.get('sex') as FormControl;
  }

  get_Form_tedadFarzandan() {
    return this.EditNewPerson.get('tedadFarzandan') as FormControl;
  }

  get_Form_vaziat_startDate() {
    return this.EditNewPerson.get('vaziat_startDate') as FormControl;
  }
  get_Form_vaziat_endDate() {
    return this.EditNewPerson.get('vaziat_endDate') as FormControl;
  }

  get_Form_shomareh_bimeh() {
    return this.EditNewPerson.get('shomareh_bimeh') as FormControl;
  }

  get_Form_ProvinceId() {
    return this.EditNewPerson.get('ProvinceId') as FormControl;
  }

  get_Form_mahal_tavalod() {
    return this.EditNewPerson.get('mahal_tavalod') as FormControl;
  }
  get_Form_codeMeli() {
    return this.EditNewPerson.get('codeMeli') as FormControl;
  }
  get_Form_name_Hamsar() {
    return this.EditNewPerson.get('name_Hamsar') as FormControl;
  }
  get_Form_name_Pedar() {
    return this.EditNewPerson.get('name_Pedar') as FormControl;
  }
  get_Form_shoghleh_Pedar() {
    return this.EditNewPerson.get('shoghleh_Pedar') as FormControl;
  }
  get_Form_codeMeli_Hamsar() {
    return this.EditNewPerson.get('codeMeli_Hamsar') as FormControl;
  }
  get_Form_shomareh_Shenasnameh() {
    return this.EditNewPerson.get('shomareh_Shenasnameh') as FormControl;
  }
  get_Form_shomareh_Shenasnameh_Seri() {
    return this.EditNewPerson.get('shomareh_Shenasnameh_Seri') as FormControl;
  }
  get_Form_shomareh_hamrah_Hamsar() {
    return this.EditNewPerson.get('shomareh_hamrah_Hamsar') as FormControl;
  }
  get_Form_shomareh_Hamreh() {
    return this.EditNewPerson.get('shomareh_Hamreh') as FormControl;
  }
  get_Form_email() {
    return this.EditNewPerson.get('email') as FormControl;
  }
  get_Form_tahsilat_Hamsar() {
    return this.EditNewPerson.get('tahsilat_Hamsar') as FormControl;
  }
  get_Form_vaziat_Nazam_Vazifeh() {
    return this.EditNewPerson.get('vaziat_Nazam_Vazifeh') as FormControl;
  }
  get_Form_vaziat_Nazam_Vazifeh_Dsc() {
    return this.EditNewPerson.get('vaziat_Nazam_Vazifeh_Dsc') as FormControl;
  }
  get_Form_vaziat_Tahol() {
    return this.EditNewPerson.get('vaziat_Tahol') as FormControl;
  }
  get_Form_tarikh_Tavalod_Hamsar() {
    return this.EditNewPerson.get('tarikh_Tavalod_Hamsar') as FormControl;
  }
  get_Form_tarikh_Tavalod() {
    return this.EditNewPerson.get('tarikh_Tavalod') as FormControl;
  }
  get_Form_maskan() {
    return this.EditNewPerson.get('maskan') as FormControl;
  }
  get_Form_address_Manzel() {
    return this.EditNewPerson.get('address_Manzel') as FormControl;
  }
  get_Form_shoghleh_Hamsar() {
    return this.EditNewPerson.get('shoghleh_Hamsar') as FormControl;
  }
  get_Form_codeposti() {
    return this.EditNewPerson.get('codeposti') as FormControl;
  }
  get_Form_tel() {
    return this.EditNewPerson.get('tel') as FormControl;
  }
  get_Form_tarikh_Eshtekhdam() {
    return this.EditNewPerson.get('tarikh_Eshtekhdam') as FormControl;
  }
  get_Form_almat_Ekhtesari() {
    return this.EditNewPerson.get('almat_Ekhtesari') as FormControl;
  }
  get_Form_field_activity_id() {
    return this.EditNewPerson.get('field_activity_id') as FormControl;
  }
  get_Form_semat_id() {
    return this.EditNewPerson.get('semat_id') as FormControl;
  }

  //#endregion


  //#region Province

  DataList_Province: Array<General_Interface> = []
  DataList_City: Array<General_Interface> = []

  Read_Service_Province(id: string) {
    this.province_Service.GetRecord(id, this.Token).subscribe(
      data => {
        if (id == "") {
          this.DataList_Province = data
          this.ReadData_Semat()
        }
        else {
          this.DataList_City = data
          if (!this.ReadData_Initial_Status) {
            this.ReadData_Initial_Status = true
            this.get_Form_mahal_tavalod().setValue(this.Edit_Record_Persone.mahal_tavalod)
          }
        }
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  ProvinceChange() {
    if (this.get_Form_ProvinceId().value == "0") {
      this.DataList_City = []
    }
    else {
      this.Read_Service_Province(this.get_Form_ProvinceId().value)
    }
  }


  //#endregion



  //#region First section tables

  Person_shomareh_hamrah_Hamsar_Array: Array<General_Interface> = []
  OnAdd_shomareh_hamrah_Hamsar() {

    var Exited: boolean = false
    for (let item of this.Person_shomareh_hamrah_Hamsar_Array) {
      if (item.title == this.get_Form_shomareh_hamrah_Hamsar().value) {
        Exited = true;
        break
      }
    }

    if (this.Person_shomareh_hamrah_Hamsar_Array.length == 3) {
      this.Alertify_Service.ErrorMessage("No more than 3 mobile numbers can be registered.")
    }
    else if (Exited) {
      this.Alertify_Service.ErrorMessage("The mobile number already exists in the list.")
    }
    else {
      var temp: General_Interface = Empty_General_Interface()
      temp.title = this.get_Form_shomareh_hamrah_Hamsar().value
      this.Person_shomareh_hamrah_Hamsar_Array.push(temp)


      this.get_Form_shomareh_hamrah_Hamsar().setValue("")
      this.Alertify_Service.SuccessMessage("The spouse mobile number was added to the list.")
    }
  }

  Person_shomareh_hamrah_Hamsar_Delete(id) {
    this.Person_shomareh_hamrah_Hamsar_Array.splice(id, 1)
    this.Alertify_Service.SuccessMessage("The spouse mobile number was removed from the list.")
  }
  ////////////////////

  Person_shomareh_Hamreh_Array: Array<General_Interface> = []
  OnAdd_shomareh_Hamreh() {

    var Exited: boolean = false
    for (let item of this.Person_shomareh_Hamreh_Array) {
      if (item.title == this.get_Form_shomareh_Hamreh().value) {
        Exited = true;
        break
      }
    }

    if (this.Person_shomareh_Hamreh_Array.length == 3) {
      this.Alertify_Service.ErrorMessage("No more than 3 mobile numbers can be registered.")
    }
    else if (Exited) {
      this.Alertify_Service.ErrorMessage("The mobile number already exists in the list.")
    }
    else {
      var temp: General_Interface = Empty_General_Interface()
      temp.title = this.get_Form_shomareh_Hamreh().value
      this.Person_shomareh_Hamreh_Array.push(temp)


      this.get_Form_shomareh_Hamreh().setValue("")
      this.Alertify_Service.SuccessMessage("The mobile number was added to the list.")
    }
  }

  Person_shomareh_Hamreh_Delete(id) {
    this.Person_shomareh_Hamreh_Array.splice(id, 1)
    this.Alertify_Service.SuccessMessage("The mobile number was removed from the list.")
  }
  /////////////////////

  Person_email_Array: Array<General_Interface> = []
  OnAdd_email() {

    var Exited: boolean = false
    for (let item of this.Person_email_Array) {
      if (item.title == this.get_Form_email().value) {
        Exited = true;
        break
      }
    }

    if (this.Person_email_Array.length == 3) {
      this.Alertify_Service.ErrorMessage("No more than 3 email addresses can be registered.")
    }
    else if (Exited) {
      this.Alertify_Service.ErrorMessage("The email address already exists in the list.")
    }
    else {
      var temp: General_Interface = Empty_General_Interface()
      temp.title = this.get_Form_email().value
      this.Person_email_Array.push(temp)


      this.get_Form_email().setValue("")
      this.Alertify_Service.SuccessMessage("The email address was added to the list.")
    }
  }

  Person_email_Delete(id) {
    this.Person_email_Array.splice(id, 1)
    this.Alertify_Service.SuccessMessage("The email address was removed from the list.")
  }
  //////////////////////
  Person_address_Manzel_Array: Array<General_Interface> = []
  OnAdd_address_Manzel() {

    var Exited: boolean = false
    for (let item of this.Person_address_Manzel_Array) {
      if (item.title == this.get_Form_address_Manzel().value) {
        Exited = true;
        break
      }
    }

    if (this.Person_address_Manzel_Array.length == 3) {
      this.Alertify_Service.ErrorMessage("No more than 3 current home addresses can be registered.")
    }
    else if (Exited) {
      this.Alertify_Service.ErrorMessage("The current home address already exists in the list.")
    }
    else {
      var temp: General_Interface = Empty_General_Interface()
      temp.title = this.get_Form_address_Manzel().value
      this.Person_address_Manzel_Array.push(temp)


      this.get_Form_address_Manzel().setValue("")
      this.Alertify_Service.SuccessMessage("The current home address was added to the list.")
    }
  }

  Person_address_Manzel_Delete(id) {
    this.Person_address_Manzel_Array.splice(id, 1)
    this.Alertify_Service.SuccessMessage("The current home address was removed from the list.")
  }
  ///////////////////////////

  Person_codeposti_Array: Array<General_Interface> = []
  OnAdd_codeposti() {

    var Exited: boolean = false
    for (let item of this.Person_codeposti_Array) {
      if (item.title == this.get_Form_codeposti().value) {
        Exited = true;
        break
      }
    }

    if (this.Person_codeposti_Array.length == 3) {
      this.Alertify_Service.ErrorMessage("No more than 3 postal codes can be registered.")
    }
    else if (Exited) {
      this.Alertify_Service.ErrorMessage("The postal code already exists in the list.")
    }
    else {
      var temp: General_Interface = Empty_General_Interface()
      temp.title = this.get_Form_codeposti().value
      this.Person_codeposti_Array.push(temp)


      this.get_Form_codeposti().setValue("")
      this.Alertify_Service.SuccessMessage("The postal code was added to the list.")
    }
  }

  Person_codeposti_Delete(id) {
    this.Person_codeposti_Array.splice(id, 1)
    this.Alertify_Service.SuccessMessage("The postal code was removed from the list.")
  }

  /////////////////////

  Person_tel_Array: Array<General_Interface> = []
  OnAdd_tel() {

    var Exited: boolean = false
    for (let item of this.Person_tel_Array) {
      if (item.title == this.get_Form_tel().value) {
        Exited = true;
        break
      }
    }

    if (this.Person_tel_Array.length == 3) {
      this.Alertify_Service.ErrorMessage("No more than 3 phone numbers can be registered.")
    }
    else if (Exited) {
      this.Alertify_Service.ErrorMessage("The phone number already exists in the list.")
    }
    else {
      var temp: General_Interface = Empty_General_Interface()
      temp.title = this.get_Form_tel().value
      this.Person_tel_Array.push(temp)


      this.get_Form_tel().setValue("")
      this.Alertify_Service.SuccessMessage("The phone number was added to the list.")
    }
  }

  Person_tel_Delete(id) {
    this.Person_tel_Array.splice(id, 1)
    this.Alertify_Service.SuccessMessage("The phone number was removed from the list.")
  }


  //#endregion


  //#region Position

  DataList_Semat: Array<General_Interface> = []
  ReadData_Semat() {
    this.Semat_Service.GetActiveList(this.Token).subscribe(
      data => {
        this.DataList_Semat = data
        this.ReadData_Initial()

      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  //#endregion


  //#region Image uploads

  modalRef_Image: any;
  ModalimageUrl: String = ''
  openModal(template: TemplateRef<any>, imageUrl: String) {
    this.ModalimageUrl = imageUrl
    this.modalRef_Image = this.modalService.show(template);
  }

  InProccessing_ax_Sign_Image: boolean = false
  uploadax_Sign_Image(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();



    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_ax_Sign_Image = true

    this.Person_Service.uploadFile(formData).subscribe(
      data => {
        this.InProccessing_ax_Sign_Image = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.Edit_Record_Persone.sign_image = data['filename']
        }
      }
    )

  }

  Remove_uploadax_Sign_Image() {
    this.Edit_Record_Persone.sign_image = ''
  }

  InProccessing_codemeli_Image1: boolean = false
  uploadcodemeli_Image1(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();
    console.log(files);


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_codemeli_Image1 = true

    this.Person_Service.uploadFile(formData).subscribe(
      data => {
        this.InProccessing_codemeli_Image1 = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.Edit_Record_Persone.codemeli_Image1 = data['filename']
        }
      }
    )

  }

  Remove_uploadcodemeli_Image1() {
    this.Edit_Record_Persone.codemeli_Image1 = ''
  }


  InProccessing_codemeli_Image2: boolean = false
  uploadcodemeli_Image2(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();
    console.log(files);


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_codemeli_Image2 = true

    this.Person_Service.uploadFile(formData).subscribe(
      data => {
        this.InProccessing_codemeli_Image2 = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.Edit_Record_Persone.codemeli_Image2 = data['filename']
        }
      }
    )

  }

  Remove_uploadcodemeli_Image2() {
    this.Edit_Record_Persone.codemeli_Image2 = ''
  }


  InProccessing_shenasNameh_Image1: boolean = false
  uploadshenasNameh_Image1(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();
    console.log(files);


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_shenasNameh_Image1 = true

    this.Person_Service.uploadFile(formData).subscribe(
      data => {
        this.InProccessing_shenasNameh_Image1 = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.Edit_Record_Persone.shenasNameh_Image1 = data['filename']
        }
      }
    )

  }

  Remove_uploadshenasNameh_Image1() {
    this.Edit_Record_Persone.shenasNameh_Image1 = ''
  }


  InProccessing_shenasNameh_Image2: boolean = false
  uploadshenasNameh_Image2(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();
    console.log(files);


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_shenasNameh_Image2 = true

    this.Person_Service.uploadFile(formData).subscribe(
      data => {
        this.InProccessing_shenasNameh_Image2 = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.Edit_Record_Persone.shenasNameh_Image2 = data['filename']
        }
      }
    )

  }

  Remove_uploadshenasNameh_Image2() {
    this.Edit_Record_Persone.shenasNameh_Image2 = ''
  }



  InProccessing_shenasNameh_Image3: boolean = false
  uploadshenasNameh_Image3(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();
    console.log(files);


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_shenasNameh_Image3 = true

    this.Person_Service.uploadFile(formData).subscribe(
      data => {
        this.InProccessing_shenasNameh_Image3 = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.Edit_Record_Persone.shenasNameh_Image3 = data['filename']
        }
      }
    )

  }

  Remove_uploadshenasNameh_Image3() {
    this.Edit_Record_Persone.shenasNameh_Image3 = ''
  }

  InProccessing_kartPayan_Khadamt_Image: boolean = false
  uploadkartPayan_Khadamt_Image(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();
    console.log(files);


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_kartPayan_Khadamt_Image = true

    this.Person_Service.uploadFile(formData).subscribe(
      data => {
        this.InProccessing_kartPayan_Khadamt_Image = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.Edit_Record_Persone.kartPayan_Khadamt_Image = data['filename']
        }
      }
    )

  }

  Remove_uploadkartPayan_Khadamt_Image() {
    this.Edit_Record_Persone.kartPayan_Khadamt_Image = ''
  }


  InProccessing_form_soe_Pishineh_Image: boolean = false
  uploadform_soe_Pishineh_Image(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();
    console.log(files);


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_form_soe_Pishineh_Image = true

    this.Person_Service.uploadFile(formData).subscribe(
      data => {
        this.InProccessing_form_soe_Pishineh_Image = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.Edit_Record_Persone.form_soe_Pishineh_Image = data['filename']
        }
      }
    )

  }

  Remove_uploadform_soe_Pishineh_Image() {
    this.Edit_Record_Persone.form_soe_Pishineh_Image = ''
  }

  InProccessing_ax_Personeli_Image: boolean = false
  uploadax_Personeli_Image(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();
    console.log(files);


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_ax_Personeli_Image = true

    this.Person_Service.uploadFile(formData).subscribe(
      data => {
        this.InProccessing_ax_Personeli_Image = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.Edit_Record_Persone.ax_Personeli_Image = data['filename']
        }
      }
    )

  }

  Remove_uploadax_Personeli_Image() {
    this.Edit_Record_Persone.ax_Personeli_Image = ''
  }

  InProccessing_ax_Personeli_Image2: boolean = false
  uploadax_Personeli_Image2(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();
    console.log(files);


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_ax_Personeli_Image2 = true

    this.Person_Service.uploadFile(formData).subscribe(
      data => {
        this.InProccessing_ax_Personeli_Image2 = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.Edit_Record_Persone.ax_Personeli_Image2 = data['filename']
        }
      }
    )

  }

  Remove_uploadax_Personeli_Image2() {
    this.Edit_Record_Persone.ax_Personeli_Image2 = ''
  }


  InProccessing_form_reserve_mosahebeh_Image: boolean = false
  uploadform_reserve_mosahebeh_Image(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();
    console.log(files);


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_form_reserve_mosahebeh_Image = true

    this.Person_Service.uploadFile(formData).subscribe(
      data => {
        this.InProccessing_form_reserve_mosahebeh_Image = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.Edit_Record_Persone.form_reserve_mosahebeh_Image = data['filename']
        }
      }
    )

  }

  Remove_uploadform_reserve_mosahebeh_Image() {
    this.Edit_Record_Persone.form_reserve_mosahebeh_Image = ''
  }


  //#endregion


  InProccessing: boolean = false

  SubmitEditNewPerson() {

    if (this.get_Form_mahal_tavalod().value == "0") {
      this.Alertify_Service.ErrorMessage("Select the place of issue.")
    }
    else {

      this.Edit_Record_Persone.shomareh_hamrah_Hamsar = '-1'
      for (let item of this.Person_shomareh_hamrah_Hamsar_Array) {
        this.Edit_Record_Persone.shomareh_hamrah_Hamsar = this.Edit_Record_Persone.shomareh_hamrah_Hamsar + "," + item.title
      }

      this.Edit_Record_Persone.shomareh_Hamreh = '-1'
      for (let item of this.Person_shomareh_Hamreh_Array) {
        this.Edit_Record_Persone.shomareh_Hamreh = this.Edit_Record_Persone.shomareh_Hamreh + "," + item.title
      }

      this.Edit_Record_Persone.email = '-1'
      for (let item of this.Person_email_Array) {
        this.Edit_Record_Persone.email = this.Edit_Record_Persone.email + "," + item.title
      }

      this.Edit_Record_Persone.address_Manzel = '-1'
      for (let item of this.Person_address_Manzel_Array) {
        this.Edit_Record_Persone.address_Manzel = this.Edit_Record_Persone.address_Manzel + "," + item.title
      }

      this.Edit_Record_Persone.tel = '-1'
      for (let item of this.Person_tel_Array) {
        this.Edit_Record_Persone.tel = this.Edit_Record_Persone.tel + "," + item.title
      }

      this.Edit_Record_Persone.codeposti = '-1'
      for (let item of this.Person_codeposti_Array) {
        this.Edit_Record_Persone.codeposti = this.Edit_Record_Persone.codeposti + "," + item.title
      }

      this.Edit_Record_Persone.id = this.EditRecord
      this.Edit_Record_Persone.fname = this.get_Form_fname().value
      this.Edit_Record_Persone.lname = this.get_Form_lname().value
      this.Edit_Record_Persone.shomareh_bimeh = this.get_Form_shomareh_bimeh().value
      this.Edit_Record_Persone.mahal_tavalod = Number(this.get_Form_mahal_tavalod().value)
      this.Edit_Record_Persone.codeMeli = Number(this.get_Form_codeMeli().value)
      this.Edit_Record_Persone.name_Hamsar = this.get_Form_name_Hamsar().value
      this.Edit_Record_Persone.name_Pedar = this.get_Form_name_Pedar().value
      this.Edit_Record_Persone.shoghleh_Pedar = this.get_Form_shoghleh_Pedar().value
      this.Edit_Record_Persone.codeMeli_Hamsar = Number(this.get_Form_codeMeli_Hamsar().value)
      this.Edit_Record_Persone.shomareh_Shenasnameh = Number(this.get_Form_shomareh_Shenasnameh().value)
      this.Edit_Record_Persone.tahsilat_Hamsar = Number(this.get_Form_tahsilat_Hamsar().value)
      this.Edit_Record_Persone.vaziat_Nazam_Vazifeh = Number(this.get_Form_vaziat_Nazam_Vazifeh().value)
      this.Edit_Record_Persone.vaziat_Nazam_Vazifeh_Dsc = this.get_Form_vaziat_Nazam_Vazifeh_Dsc().value
      this.Edit_Record_Persone.vaziat_Tahol = Number(this.get_Form_vaziat_Tahol().value)
      this.Edit_Record_Persone.tarikh_Tavalod_Hamsar = this.get_Form_tarikh_Tavalod_Hamsar().value
      this.Edit_Record_Persone.tarikh_Tavalod = this.get_Form_tarikh_Tavalod().value
      this.Edit_Record_Persone.maskan = Number(this.get_Form_maskan().value)
      this.Edit_Record_Persone.shoghleh_Hamsar = this.get_Form_shoghleh_Hamsar().value
      this.Edit_Record_Persone.tarikh_Eshtekhdam = this.get_Form_tarikh_Eshtekhdam().value
      this.Edit_Record_Persone.almat_Ekhtesari = this.get_Form_almat_Ekhtesari().value
      this.Edit_Record_Persone.field_activity_id = Number(this.get_Form_field_activity_id().value)
      this.Edit_Record_Persone.semat_id = Number(this.get_Form_semat_id().value)
      this.Edit_Record_Persone.sabegh = Number(this.get_Form_sabegh().value)
      this.Edit_Record_Persone.tedadFarzandan = Number(this.get_Form_tedadFarzandan().value)
      this.Edit_Record_Persone.shomareh_Shenasnameh_Seri = this.get_Form_shomareh_Shenasnameh_Seri().value

      this.InProccessing = true
      this.Person_Service.EditPersone(
        this.Edit_Record_Persone,
        this.Token).subscribe(
          data => {
            this.InProccessing = false
            this.Alertify_Service.SuccessMessage("Information saved successfully.")

          }, error => {
            localStorage.clear()
            location.reload();

          }
        )

    }

  }








}
